import { clsx } from 'clsx'
import { type FC, type MouseEventHandler, type PropsWithChildren } from 'react'

import { IconArrowRight } from '@redteclab/icons'

import { Link, Skeleton } from 'base-ui'

import { EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_SHOW_ALL_PRODUCTS_CLICK } from '../../../experiments/eventTracking'
import { recommendationExperimentsTrackRecommendationEvent } from '../../recommendation-experiments'
import { useRecommendationWidgetContext } from '../RecommendationAreaProvider'

type RecommendationWidgetMoreLinkProps = PropsWithChildren<{
  className?: string
  href?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}>

export const RecommendationWidgetMoreLink: FC<
  RecommendationWidgetMoreLinkProps
> = ({ children, className, href, onClick }) => {
  const { moreHref, serviceId, widgetId } = useRecommendationWidgetContext()
  const link = moreHref ?? href

  if (!link) {
    return (
      <Skeleton
        className={clsx(
          'recommendations-area-more-link recommendations-area-more-link_skeleton',
          className,
        )}
      />
    )
  }

  return (
    <Link
      className={clsx('recommendations-area-more-link', className)}
      color="inherit"
      href={link}
      onClick={(event) => {
        recommendationExperimentsTrackRecommendationEvent({
          eventKey:
            EXPERIMENTS_TRACK_EVENT_RECOMMENDATION_SHOW_ALL_PRODUCTS_CLICK,
          serviceId,
          widgetId,
        })
        onClick?.(event)
      }}
    >
      {children}
      <IconArrowRight className="size-6 text-dark-brand" />
    </Link>
  )
}
